module.exports = __webpack_public_path__ + "img/cancel.170b6957.svg";